import { useCityviseApartment } from "../../assets/api/useMarketingExecutive"
import useAuthStore from "../../store/useAuthStore"
import CommonTermAndCondtion from "../commonfile/CommonTermAndCondtion"

const ZoneManagerTCList = () => {
    const { user } = useAuthStore()
    const { data: CityApartmentList, isLoading: isCityApartmentListLoading } = useCityviseApartment({ city_name: user?.city })
    return (
        <CommonTermAndCondtion apartmentRow={CityApartmentList?.data} isloadingApartment={isCityApartmentListLoading} />
    )
}

export default ZoneManagerTCList